"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Profile = void 0;
const identity_reducer_1 = require("@app/store/reducers/identity.reducer");
const profile_avatar_1 = require("@shared-modules/components/profile-avatar");
const outside_click_hooks_1 = require("@shared-modules/utils/hooks/outside-click.hooks");
const object_1 = require("@utils/object");
const core_1 = require("@web3-react/core");
const React = __importStar(require("react"));
const react_collapse_1 = require("react-collapse");
const react_router_dom_1 = require("react-router-dom");
const unknown_png_1 = __importDefault(require("@assets/unknown.png"));
require("./styles.scss");
const translation_hooks_1 = require("@hooks/translation.hooks");
const cart_reducer_1 = require("@app/store/reducers/cart.reducer");
const Profile = (props) => {
    const { disconnect } = props;
    const { account } = (0, core_1.useWeb3React)();
    const profile = (0, identity_reducer_1.useCurrentUser)();
    const [isVisible, setVisibility] = React.useState(false);
    const closeHandler = () => setVisibility(false);
    const translator = (0, translation_hooks_1.useComponentTranslation)("navigation.miniProfile");
    const togglePopupVisibility = (0, cart_reducer_1.useCartToggler)();
    (0, outside_click_hooks_1.useOutsideClick)(() => document.querySelector(".c-header-profile"), closeHandler, [closeHandler]);
    return (React.createElement("div", { className: "c-header-profile" },
        React.createElement("div", { className: "c-header-profile__avatar-wrapper" },
            React.createElement("span", null, (0, object_1.formatAddress)(account || "")),
            React.createElement(profile_avatar_1.ProfileAvatar, { src: unknown_png_1.default, onClick: () => setVisibility(!isVisible), height: "34px", width: "34px" })),
        React.createElement("div", { className: "c-header-profile__menu" },
            React.createElement("div", { className: "c-header-profile__menu-container" },
                React.createElement(react_collapse_1.UnmountClosed, { isOpened: isVisible },
                    React.createElement("div", { className: "c-header-profile__menu-section" },
                        React.createElement("div", { className: "c-header-profile__menu-list" },
                            React.createElement("div", { className: "c-header-profile__account" }, (0, object_1.formatAddress)(account || "")),
                            (profile === null || profile === void 0 ? void 0 : profile.isAdmin) && (React.createElement(react_router_dom_1.Link, { className: "c-header-profile__nav-item", to: "/admin" }, translator("adminLinkLabel"))),
                            React.createElement(react_router_dom_1.Link, { className: "c-header-profile__nav-item", to: "/profile" }, translator("profileLinkLabel")),
                            React.createElement("a", { className: "c-header-profile__nav-item", onClick: () => {
                                    togglePopupVisibility();
                                    closeHandler();
                                } }, translator("cartLinkLabel"))),
                        React.createElement("div", { className: "c-header-profile__disconnect" },
                            React.createElement("div", { onClick: disconnect, className: "g-link" }, translator("disconnectButton")))))))));
};
exports.Profile = Profile;
